import { Params } from "~/constants/request";

import { pushHistoryState } from "../history";

export const removePageFromUrl: (
  searchParams: URLSearchParams,
  pathname: string,
  removeOnlyHash?: boolean,
) => void = (searchParams, pathname, removeOnlyHash): void => {
  const query = new URLSearchParams(searchParams);
  const pageName = searchParams.get(Params.PAGE);
  const hash = location.hash || "";

  if (pageName || removeOnlyHash) {
    if (!removeOnlyHash) {
      query.delete(Params.PAGE);
    }

    const queryString = query.toString();
    const queryStringWithDelimiter = queryString ? `?${queryString}` : "";
    const finalHashString = removeOnlyHash ? "" : hash;
    pushHistoryState(`${pathname}${queryStringWithDelimiter}${finalHashString}`, {
      pathname,
    });
  }
};
